import { styled, FormControl, MenuItem } from '@mui/material';
import { COLORS } from '../../../configs/colors';

export const StyledFormControl = styled(FormControl)`
  min-width: 400px;
`;

export const StyledMenuItem = styled(MenuItem)`
  min-width: 400px;
  max-width: 400px;
`;

export const MicroText = styled('p')`
  margin: 0;
  height: 20px;
  font-size: 10px;
  font-weight: bold;
  overflow-wrap: break-word;
  color: ${COLORS.DarkGray};
`;
